import EventActionProto from '../event-action-proto'

export default class SessionDocumentDelete extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            document    : sessionEvent.document,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        if (this.isDifferentCompany()) return false

        gd.modelBus.newUpdate('document', this.method, this.header.document.id, this.data, this.header)
    }
};
